module.exports = __webpack_public_path__ + "img/玛利亚.8145422.png";